import React, { useState, useEffect } from 'react';
import { Layout, Spin, Alert, Card, PageHeader, Space } from 'antd';
import { getStartPage } from '../util/APIUtils';
import './ViewStartPage.css';

const { Content } = Layout;

const ViewStartPage = () => {
    const [pageContent, setPageContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const response = await getStartPage();
                if (response && response.content) {
                    setPageContent(response.content);
                }
            } catch (err) {
                console.error("Failed to fetch start page content:", err);
                setError("Could not load the page content. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchContent();
    }, []);

    if (loading) {
        return <Spin size="large" tip="Loading Page..." />;
    }

    if (error) {
        return <Alert message="Error" description={error} type="error" showIcon />;
    }

    return (
         <><PageHeader
            className="site-page-header"
            title={""} /><Card bordered={true} headStyle={{ padding: "0" }} loading={loading}>
                    {/* <Content className="view-start-page-content"> */}
                        <Card bordered={false}>

                            <div dangerouslySetInnerHTML={{ __html: pageContent }} />
                        </Card>
                    {/* </Content> */}
            </Card></>

    );
};

export default ViewStartPage;